import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEnum, IsInstance, IsNotEmpty, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { ServiceChargeTypeEnum } from '../../service-charge';
import { OrderExposeGroup } from '../interface';
import { PatchChargeInfoDto } from './PatchChargeInfoDto';
import { PatchChargeTotalAmountsDto } from './PatchChargeTotalAmountsDto';
import { PatchChargeTotalDto } from './PatchChargeTotalDto';
import { PatchTaxInfoDto } from './PatchTaxInfoDto';
export class PatchOrderServiceChargeDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'Fuel Surcharge' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderServiceChargeDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ enum: ServiceChargeTypeEnum, example: ServiceChargeTypeEnum.DELIVERY_FEE }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(ServiceChargeTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchOrderServiceChargeDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchTaxInfoDto }),
    Type(() => PatchTaxInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchTaxInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchTaxInfoDto)
], PatchOrderServiceChargeDto.prototype, "tax", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchChargeInfoDto }),
    Type(() => PatchChargeInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchChargeInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchChargeInfoDto)
], PatchOrderServiceChargeDto.prototype, "charge", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchChargeTotalDto }),
    Type(() => PatchChargeTotalDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchChargeTotalDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchChargeTotalDto)
], PatchOrderServiceChargeDto.prototype, "total", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchChargeTotalAmountsDto }),
    Type(() => PatchChargeTotalAmountsDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchChargeTotalAmountsDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchChargeTotalAmountsDto)
], PatchOrderServiceChargeDto.prototype, "totalAmounts", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'if the value is true, it means that the amounts are not final', example: false }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchOrderServiceChargeDto.prototype, "isApproximate", void 0);
//# sourceMappingURL=PatchOrderServiceChargeDto.js.map